import React from 'react';

const ElementIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">book</span>
            </>
      );
};

export default ElementIcon;
